<template>
  <div class="box">
    <v-row>
      <v-col cols="12">
        <v-expansion-panels :value="panel" accordion multiple hover tile readonly>
          <v-expansion-panel :style="upperPanelHeight">
            <v-expansion-panel-header hide-actions>Profile</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- eslint-disable-next-line prettier/prettier -->
              <tree-data-table
                :headers="profileHeaders" :items="profileTree" item-key="key" :height="upperTableHeight"
                @click:row="arrangeTcodGrid"
                dense hide-default-footer disable-pagination fixed-header single-select>
                <template #item.typ="{ value }"> {{ value.text }} </template>
                <template #item.modDatim="{ value }"> {{ value | format('yyyy-MM-dd') }} </template>
                <template #item.assignDatim="{ value }"> {{ value | format('yyyy-MM-dd') }} </template>
              </tree-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :style="lowerPanelHeight">
            <v-expansion-panel-header hide-actions>T-Code</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="3">
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-data-table
                    :headers="tcodHeaders" :items="tcodGrid" item-key="tcode" class="elevation-1 content"
                    :options.sync="options" :items-per-page="paging.rowsPerPage"
                    :height="lowerPagingTableHeight" :loading="tcodLoading"
                    @click:row="arrangeAuthTree"
                    dense hide-default-footer disable-pagination fixed-header single-select>
                    <template v-slot:footer>
                      <pagination :paging.sync="paging" :length="length" :disabled="tcodLoading" :dense="true"></pagination>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="9">
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <tree-data-table
                    :headers="authHeaders" :items="authTree" item-key="label"
                    :height="lowerTableHeight" :loading="authLoading"
                    @click:expand="expandAuthNode"
                    dense hide-default-footer disable-pagination fixed-header single-select>
                    <template #item.descrMap="{ value }">
                      <span :style="cssDescription(value.foreColor)" small>{{ value.text }}</span>
                    </template>
                    <template #item.checkIn="{ item }">
                      <span small>{{ getCheckIn(item) }}</span>
                    </template>
                    <template #item.proposal="{ item }">
                      <span small>{{ getProposal(item) }}</span>
                    </template>
                    <template #item.tstcaMap="{ value }">
                      <v-icon @click="tstcaDetail(value)" :style="cssTstcaColor(value.circleColor)" small>mdi-circle</v-icon>
                    </template>
                  </tree-data-table>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- Dialog to show TSTCA detail -->
    <v-dialog v-model="showTstcaDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <v-icon color="primary">mdi-information</v-icon>
          <span style="padding-left:10px">TSTCA</span>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="valueInitHeaders" :items="valueInitGrid" item-key="field" dense hide-default-footer disable-pagination fixed-header single-select>
            <template #item.descrMap="{ value }">
              <span :style="cssDescription(value.foreColor)" small>{{ value.text }}</span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showTstcaDialog = !showTstcaDialog">{{ this.$t('common.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { api } from '@/api/common/instances';
import { isEmpty } from 'lodash';
import share from './searchShare.js';
export default {
  props: {
    height: {
      type: Number,
    },
    profileTree: {
      type: Array,
    },
  },
  mixins: [share],
  data() {
    return {
      // data 'panel'은 내부의 panel 모두가 디폴트로 펼쳐져서 content가 보이게 하기 위한 조치.
      panel: [0, 1],
      tcodHeaders: [
        { text: 'T-Code', value: 'tcode', width: '25%', expandable: true, sortable: false },
        { text: 'Description', value: 'ttext', sortable: false },
      ],
      authHeaders: [
        { text: 'Object/Filed', value: 'label', width: '25%', expandable: true, sortable: false },
        { text: 'Description', value: 'descrMap', sortable: false },
        { text: 'Check in', value: 'checkIn', sortable: false },
        { text: 'Proposal', value: 'proposal', sortable: false },
        { text: 'From', value: 'formattedLowText', sortable: false },
        { text: 'To', value: 'formattedHighText', sortable: false },
        { text: 'TSTCA', value: 'tstcaMap', sortable: false },
      ],
      valueInitHeaders: [
        { text: 'Field', value: 'field', width: '25%', expandable: true, sortable: false },
        { text: 'Description', value: 'descrMap', sortable: false },
        { text: 'Value', value: 'formattedValueText', sortable: false },
      ],
      selectedProfile: {},
      tcodGrid: [],
      authTree: [],
      valueInitGrid: [],
      tcodLoading: false,
      authLoading: false,
      length: 0,
      paging: { page: 1, rowsPerPage: 20 },
      options: {},
      showTstcaDialog: false,
    };
  },
  computed: {
    lowerPagingTableHeight() {
      return (this.height / 5) * 3 - 80;
    },
  },
  watch: {
    paging: {
      deep: true,
      handler() {
        this.getTcodeList();
      },
    },
  },
  methods: {
    async arrangeTcodGrid(profileNode, { select, isSelected }) {
      select(!isSelected);
      this.selectedProfile = profileNode;
      this.paging.page = 1;
      await this.getTcodeList();
    },
    async getTcodeList() {
      this.tcodLoading = true;
      // eslint-disable-next-line prettier/prettier
      const { data: { items, pagination }} = await api.get('/rtrck/search/prfl-tcod', {
        params: {
          svrYmdhms: this.selectedProfile.svrYmdhms,
          sstmId: this.selectedProfile.sstmId,
          mandt: this.selectedProfile.mandt,
          profn: this.selectedProfile.profn,
          aktps: this.selectedProfile.aktps,
          page: this.paging.page,
          limit: this.paging.rowsPerPage,
        },
      });
      // console.log('in ProfileTcode getTcodeList()... items=', items);
      this.length = pagination.totalCount;
      this.tcodGrid = items;
      this.authTree = [];
      this.tcodLoading = false;
    },
    async arrangeAuthTree(tcodNode, { select, selected }) {
      select(!selected);
      let param = {};
      param.svrYmdhms = tcodNode.svrYmdhms;
      param.sstmId = tcodNode.sstmId;
      param.name = tcodNode.tcode;
      param.dtype = 'I'; // 최초(Init...)의 의미로 'I'를 부여한다.
      this.authTree = await this.getTcodeAuthTree(param);
    },
    async expandAuthNode(node, { add }) {
      if (node._opened) return;
      let authTree = await this.getTcodeAuthTree(node);
      // 현재 tree는 expand 시 추가되는 자식은 순서를 거꾸로 해주어야 한다.2021.01.11.KWShin.
      authTree = authTree.reverse();
      add(authTree);
    },
    async getTcodeAuthTree(node) {
      this.authLoading = true;
      const { data } = await api.get('/rtrck/search/tcod-auth', {
        params: {
          svrYmdhms: node.svrYmdhms,
          sstmId: node.sstmId,
          name: node.name,
          type: node.type,
          object: node.object,
          dtype: node.dtype,
        },
      });
      // Proposal이 'Y'인 TcodeAuth('O')만이 TcodAuthVal을 갖는다.
      data.forEach(elm => {
        elm.children = [];
        if (elm.dtype == 'O' && elm.okflag.value == 'Y') elm.leaf = false;
        else elm.leaf = true;
      });
      // console.log('in ProfileAuth getProfileAuthTree()... data=', data);
      this.authLoading = false;
      return data;
    },
    cssDescription(color) {
      if (!isEmpty(color)) {
        // 원래 서버에서 '#0000FF'를 내려주는데 이는 dark 테마에서 잘 안보인다.
        if (this.$vuetify.theme.isDark) return 'color: #BBBBFF';
        return `color: ${color}`;
      }
    },
    getCheckIn(item) {
      return item.dtype == 'O' ? item.okflag.checkIndeed : '';
    },
    getProposal(item) {
      return item.dtype == 'O' ? item.okflag.proposal : '';
    },
    cssTstcaColor(color) {
      return 'G' == color ? 'color: green;' : `color: ${color}`;
    },
    async tstcaDetail(value) {
      // console.log('in ProfileTcode tstcaDetail()... ', value);
      if (value.circleColor == 'G') {
        const { data } = await api.get('/rtrck/search/tcod-auth-init', {
          params: {
            svrYmdhms: value.svrYmdhms,
            sstmId: value.sstmId,
            tcode: value.name,
            objct: value.object,
          },
        });
        this.valueInitGrid = data;
        // console.log('in ProfileTcode getTcodeList()... tcodeAuthValueInit=', this.valueInitGrid);
        this.showTstcaDialog = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-expansion-panel-content ::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
